export const tickerItems = [
  '顶流剧组临阵换角，对赌条款浮出水面',
  '某MCN机构被指批量孵化“同款人设”',
  '饭圈打投工作室流水首次被拆解',
  '资本方三重股权代持疑云',
  '网红直播基地的保底协议曝光',
  '幕后推手名单新增三名操盘手',
  '娱乐圈内幕：宣发预算的真实去向',
  '行业黑幕：刷量平台的定价表流出',
];

export const flashFeed = [
  {
    id: 'f-01',
    time: '09:12',
    channel: '娱乐圈',
    title: '某顶流影视项目临阵换角，牵出对赌条款',
    summary:
      '知情人士称，换角并非档期冲突，而是资方为完成年度对赌指标所做的资源置换。剧组内部通告单出现两版演员表。',
    heat: '9.8万',
    hot: true,
  },
  {
    id: 'f-02',
    time: '08:47',
    channel: '网红圈',
    title: 'MCN批量孵化同款人设，脚本库共享同一套话术',
    summary:
      '三个不同账号在四十八小时内发布了结构完全一致的“素人逆袭”视频，配音与运镜模板高度重合，指向同一家机构。',
    heat: '7.2万',
    hot: true,
  },
  {
    id: 'f-03',
    time: '08:05',
    channel: '饭圈',
    title: '打投工作室流水被拆解：一笔钱转了三道手',
    summary:
      '粉丝集资进入第三方代付通道后，再以“应援物料采购”名义回流，中间损耗比例远高于对外公布的公示口径。',
    heat: '6.4万',
    hot: false,
  },
  {
    id: 'f-04',
    time: '07:33',
    channel: '资本',
    title: '三重股权代持疑云：谁是真正的签约方',
    summary:
      '一家注册于写字楼的小公司，同时出现在五个艺人的经纪合约底层结构中，法人信息与公开报道存在明显出入。',
    heat: '5.9万',
    hot: true,
  },
  {
    id: 'f-05',
    time: '23:58',
    channel: '网红圈',
    title: '直播基地保底协议曝光，销量数字被写进对赌条',
    summary:
      '协议要求主播在周期内完成约定GMV，未达标部分按比例返还坑位费，这一模式正在被更多中小机构复制。',
    heat: '5.1万',
    hot: false,
  },
  {
    id: 'f-06',
    time: '22:41',
    channel: '娱乐圈',
    title: '宣发预算去向成谜，八成费用落在同一批渠道',
    summary:
      '一份流出的投放结算单显示，多个看似独立的营销账号背后指向同一实际控制人，形成闭环式曝光。',
    heat: '4.8万',
    hot: false,
  },
  {
    id: 'f-07',
    time: '21:16',
    channel: '饭圈',
    title: '控评组织分工手册流出，层级比想象中更细',
    summary:
      '手册将成员分为巡查、文案、转发、数据四组，并规定每日打卡时段，管理方式接近标准化运营团队。',
    heat: '4.2万',
    hot: true,
  },
  {
    id: 'f-08',
    time: '19:02',
    channel: '资本',
    title: '幕后推手名单更新，三名操盘手首次被点名',
    summary:
      '三人分别负责资源对接、舆情处置与数据包装，在近两年的多个热点事件中反复出现，形成稳定的协作组合。',
    heat: '3.9万',
    hot: false,
  },
  {
    id: 'f-09',
    time: '17:25',
    channel: '网红圈',
    title: '刷量平台定价表流出，层级报价相差十倍',
    summary:
      '同一批数据服务在代理与直客之间存在巨大价差，“保真实”“保留存”的承诺被内部备注为不可核验项。',
    heat: '3.4万',
    hot: false,
  },
  {
    id: 'f-10',
    time: '15:40',
    channel: '娱乐圈',
    title: '选角工作坊被指收取“包装费”，流程缺乏透明',
    summary:
      '多位参与者提到同一套收费话术，费用名目从形象设计到资源推荐不等，但最终入选名单从未公开。',
    heat: '2.8万',
    hot: false,
  },
];